import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "d-flex mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down p-2 my-auto text-muted" }, null, -1)
const _hoisted_4 = { class: "d-flex flex-wrap flex-column flex-1" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "d-flex flex-1" }
const _hoisted_7 = { class: "d-flex mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down p-2 my-auto text-muted" }, null, -1)
const _hoisted_9 = { class: "d-flex flex-wrap flex-column flex-1" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-flex flex-1" }
const _hoisted_12 = { class: "d-flex mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down p-2 my-auto text-muted" }, null, -1)
const _hoisted_14 = { class: "d-flex flex-wrap flex-column flex-1" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "d-flex flex-1" }
const _hoisted_17 = { class: "d-flex mt-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down p-2 my-auto text-muted" }, null, -1)
const _hoisted_19 = { class: "d-flex flex-wrap flex-column flex-1" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "d-flex flex-1" }
const _hoisted_22 = { class: "d-flex mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down p-2 my-auto text-muted" }, null, -1)
const _hoisted_24 = { class: "d-flex flex-wrap flex-column flex-1" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "d-flex flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "4rem"
      }),
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "2.5rem"
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Skeleton, {
            class: "mb-2 mr-1",
            height: "1.6rem",
            width: "5rem"
          }),
          _createVNode(_component_Skeleton, {
            class: "mb-2",
            width: "10rem"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Skeleton, {
            class: "mr-1",
            height: "1rem",
            width: "20%"
          }),
          _createVNode(_component_Skeleton, {
            class: "",
            height: "1rem",
            width: "80%"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "4rem"
      }),
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "2.5rem"
      }),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Skeleton, {
            class: "mb-2 mr-1",
            height: "1.6rem",
            width: "5rem"
          }),
          _createVNode(_component_Skeleton, {
            class: "mb-2",
            width: "10rem"
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Skeleton, {
            class: "mr-1",
            height: "1rem",
            width: "60%"
          }),
          _createVNode(_component_Skeleton, {
            class: "",
            height: "1rem",
            width: "40%"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "4rem"
      }),
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "2.5rem"
      }),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Skeleton, {
            class: "mb-2 mr-1",
            height: "1.6rem",
            width: "5rem"
          }),
          _createVNode(_component_Skeleton, {
            class: "mb-2",
            width: "10rem"
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Skeleton, {
            class: "mr-1",
            height: "1rem",
            width: "34%"
          }),
          _createVNode(_component_Skeleton, {
            class: "",
            height: "1rem",
            width: "66%"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "4rem"
      }),
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "2.5rem"
      }),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Skeleton, {
            class: "mb-2 mr-1",
            height: "1.6rem",
            width: "5rem"
          }),
          _createVNode(_component_Skeleton, {
            class: "mb-2",
            width: "10rem"
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Skeleton, {
            class: "mr-1",
            height: "1rem",
            width: "89%"
          }),
          _createVNode(_component_Skeleton, {
            class: "",
            height: "1rem",
            width: "11%"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "4rem"
      }),
      _createVNode(_component_Skeleton, {
        class: "mr-2",
        height: "4rem",
        shape: "square",
        width: "2.5rem"
      }),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Skeleton, {
            class: "mb-2 mr-1",
            height: "1.6rem",
            width: "5rem"
          }),
          _createVNode(_component_Skeleton, {
            class: "mb-2",
            width: "10rem"
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_Skeleton, {
            class: "mr-1",
            height: "1rem",
            width: "34%"
          }),
          _createVNode(_component_Skeleton, {
            class: "",
            height: "1rem",
            width: "66%"
          })
        ])
      ])
    ])
  ]))
}